import { cva } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'

export const alertVariants = cva(
    'relative w-full rounded-lg border px-4 py-3 text-sm',
    {
        variants: {
            variant: {
                default: 'border-gray-200 bg-gray-50 text-gray-800',
                info: 'border-blue-200 bg-blue-50 text-blue-800',
                destructive: 'border-red-200 bg-red-50 text-red-800',
                success: 'border-green-200 bg-green-50 text-green-800',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)
